// store/notifications.js
import { defineStore } from 'pinia';
import { useUserStore } from '@store/user';
import { toast } from 'vue-sonner';

export const useNotificationsStore = defineStore('notifications', {
    state: () => {
        return {
            loading: false,
            all: [],
            listener: null,
            inactive_status_code: useStorage('inactive_status_code', null),
            inactive_status: useStorage('inactive_status', null),
            inactive_dismissible: useStorage('inactive_dismissible', false),
        };
    },
    actions: {
        add(notification) {
            toast(notification.data.message, {
                position: 'top-center',
            });
            this.all = [notification, ...this.all];
        },

        async retrieve() {
            this.loading = true;
            const response = await window.tenantAxios.get('me/notifications');
            this.all = response.data.data;
            this.loading = false;
        },

        /*
         * NotificationIds are comma separated string of uuids for the notifications to be modified
         */
        async read(notificationIds) {
            this.loading = true;

            await window.tenantAxios.post('me/notifications/read', {
                ids: notificationIds,
            });

            console.log('read', notificationIds);

            await this.retrieve();

            this.loading = false;
        },

        async markAllRead() {
            this.loading = true;

            const unreadNotifications = this.all.filter((notification) => !notification.read_at);
            let promises = [];
            unreadNotifications.forEach((notification) => {
                promises.push(this.read(notification.id));
            });
            await Promise.allSettled(promises);

            await this.retrieve();
            this.loading = false;
        },

        startListener() {
            const user = useUserStore();
            this.listener = window.echo.private(`App.Models.User.${user.getUser.id}`).notification((notification) => {
                this.add({
                    data: {
                        message: notification.message,
                        url: notification.url,
                    },
                    id: notification.id,
                    type: notification.type,
                    read_at: null,
                });
            });
        },
    },
    getters: {
        getUnreadCount: (state) => {
            return state.all.reduce((accumulator, currentValue) => {
                if (!currentValue.read_at) {
                    accumulator = accumulator + 1;
                }
                return accumulator;
            }, 0);
        },

        getAllCount: (state) => {
            if (state.all && state.all.length) {
                return state.all.length;
            }
        },

        getUnread: (state) => {
            return state.unread;
        },

        getAll: (state) => {
            return state.all;
        },
    },
});
